exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".kye-area-content-layout .content-wrap {\n  width: 468px;\n  overflow: hidden; }\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/components/kye-area/style/area-panel.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB,EAAE","file":"area-panel.scss","sourcesContent":[".kye-area-content-layout .content-wrap {\n  width: 468px;\n  overflow: hidden; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader??ref--10-2!./node_modules/postcss-loader/lib??ref--10-3!./node_modules/fast-sass-loader/lib??ref--10-4!./src/public/components/kye-area/style/area-panel.scss
// module id = JnIx
// module chunks = 6